import { Injectable, signal, WritableSignal } from '@angular/core';
import { UserServiceClient } from '../proto/generated/User_Service_pb_service';
import {
  UserEmailRequest,
  UserResponse,
} from '../proto/generated/User_Service_pb';
import { UserEmail } from '../proto/generated/User_message_pb';
import { UserModel } from 'src/app/shared/models';

import { BaseGRRCService } from '../shared/services/base.service';

@Injectable({ providedIn: 'root' })
export class UserGRPCService extends BaseGRRCService<UserServiceClient> {
  user: WritableSignal<UserModel> = signal(null);
  initialized: WritableSignal<boolean> = signal(false);

  constructor() {
    super(UserServiceClient);
    // this.client = new UserServiceClient('https://groupmanagementapi.devcloud.olameter.com/backend');

    this.getApplicationBEVersion()
      .then((data: any) => {})
      .catch((reason) => {
        this.showConnectionError('NOTIFICATIONS.SERVICES.USER', reason);
      });
  }

  public async getAsyncByEmail(email: string) {
    if (email && this.initialized() === false) {
      this.initialized.set(true);
      const request = new UserEmailRequest();
      const userEmail = new UserEmail();
      userEmail.setEmail(email);
      request.setUserEmail(userEmail);

      const requestOptions = await this.getGrpcRequestOptions();
      this.client.getUserByEmail(
        request,
        requestOptions,
        (error, response: UserResponse) => {
          if (error) {
            this.handleError(error);
          } else {
            const userResponse = response.getUserResult();
            const userGroups = UserModel.Mapper(userResponse);
            this.user.set(userGroups);
          }
        }
      );
    }
  }
}
